






import { defineComponent, computed } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
// import GoogleModelViewer from '@/components/GoogleModelViewer.vue';
import TeacTn4dGlb from '../assets/3d-models/teac_tn4d.glb';
import TeacTn4dUsdz from '../assets/3d-models/teac_tn4d.usdz';
import Th1210Glb from '../assets/3d-models/th_1210.glb';
import Th1210Usdz from '../assets/3d-models/th_1210.usdz';
import Philips423Glb from '../assets/3d-models/philips423.glb';
import Philips423Usdz from '../assets/3d-models/philips423.usdz';

export default defineComponent({
  components: { ViewContainer, GoogleModelViewer: () =>
  import('@/components/GoogleModelViewer.vue')
, },
  props: {
    playerName: {
      type: String,
      default: 'RecordPlayerPhilips',
    },
  },
  name: 'VirtualPlayer',
  setup(props) {
    const currentGLTFUrl = computed(() => {
      switch (props.playerName) {
        case 'RecordPlayerTechnics':
          return [Th1210Glb, Th1210Usdz];
        case 'RecordPlayerTeac':
          return [TeacTn4dGlb, TeacTn4dUsdz];
        default:
        case 'RecordPlayerPhilips':
          return [Philips423Glb, Philips423Usdz];
      }
    });
    return { currentGLTFUrl };
  },
});
